import React from 'react';
import { Progress } from '@/components/shared/progress';

interface AssessmentProgressProps {
  currentDimension: number;
  totalDimensions: number;
}

const AssessmentProgress = ({ currentDimension, totalDimensions }: AssessmentProgressProps) => {
  const progress = ((currentDimension + 1) / totalDimensions) * 100;

  return (
    <div className="mb-12">
      <h1 className="text-3xl font-bold text-[#1A1F2C] mb-6">Readiness Assessment</h1>
      <div className="flex items-center gap-4">
        <span className="text-sm font-medium text-[#8E9196] min-w-[120px]">
          Step {currentDimension + 1} of {totalDimensions}
        </span>
        <Progress 
          value={progress} 
          className="flex-1 h-2 bg-[#f3f3f3]"
        />
      </div>
    </div>
  );
};

export default AssessmentProgress;